import { getImageUrlFromFilename } from '../../vitl-services/services/format';
import React from 'react';

interface IProps {
  filename?: string;
  url?: string;
  title?: string;
  width?: number | string;
  height?: number | string;
  heightQp?: number;
  lazyload?: boolean;
  className?: string;
}

const ResponsiveResolutionImage: React.FC<IProps> = ({
  filename,
  url,
  title = '',
  className = '',
  width = 'auto',
  height = 'auto',
  heightQp, //query param height
}) => {
  const imgPath = url || getImageUrlFromFilename(filename || '');

  const queryParams = (factor: number = 1) => {
    if (url) return '';
    return heightQp ? `?h=${factor * heightQp}` : '';
  };

  return (
    <img
      width={width}
      height={height}
      className={className}
      srcSet={`
        ${imgPath}${queryParams()} 1x,
        ${imgPath}${queryParams(2)} 2x
      `}
      src={`${imgPath}${queryParams()}`}
      alt={title}
    />
  );
};

export default ResponsiveResolutionImage;
